import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { CommonReducers } from './'
import { BuildingSearchReducers } from './building/buildingsearch-state'
import { ConfirmReplyReducers } from './supplier/confirmreply-state'
import { SupplierSearchReducers } from './supplier/supplierSearch-state'
import { StatusCheckReducers } from './supplier/statuscheck-state'
import { BuildingHistoryReducers } from './building/buildinghistory-state'
import { SimulationBuildingSearchReducers } from './simulation/simulationbuildingsearch-state'
import { DataExportConditionReducers } from './simulation/statuslist-state'

// リデューサ定義
// ※スライスを追加した際は、ここにリデューサを定義します。
const reducers = {
  common: CommonReducers,
  buildingsearch: BuildingSearchReducers,
  confirmreply: ConfirmReplyReducers,
  supplierSearch: SupplierSearchReducers,
  statuscheck: StatusCheckReducers,
  buildingHistory: BuildingHistoryReducers,
  simulationbuildingsearch: SimulationBuildingSearchReducers,
  dataExport: DataExportConditionReducers
}

// エクスポート定義
// ※スライスを追加した際は、ここにエクスポートを定義します。
export * from './common/common-state'
export * from './building/buildingsearch-state'
export * from './supplier/confirmreply-state'
export * from './supplier/supplierSearch-state'
export * from './supplier/statuscheck-state'
export * from './building/buildinghistory-state'
export * from './simulation/simulationbuildingsearch-state'
export * from './simulation/statuslist-state'

/// ////////////////////////////////////////////////////////////////////////////

// データストア定義
export const applicationDataStore = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['common/setPageTitle', 'common/setInitialData'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['common.initialData', 'payload.userProp'],
        // Ignore these paths in the state
        ignoredPaths: ['common.initialData', 'payload', 'payload.userProp', 'common.userProp']
      }
    })
})

export type ApplicationDataStore = ReturnType<typeof applicationDataStore.getState>
export type ApplicationDispatch = typeof applicationDataStore.dispatch

export const useAppDispatch: () => ApplicationDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<ApplicationDataStore> = useSelector
